import {Component, NgZone, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import {StorageService} from '../../provider/storage/storage.service';
import {SharedDataService} from '../../provider/shared-data/shared-data.service';
import {fromEvent, Observable, Subscription, of} from 'rxjs';
import {IQApiService} from '../../provider/iqapi/iqapi.service';
import {
	CheckRelationsObject,
	ConfigurationObject,
	IQApiResultObject, LockObject,
	SearchObjectsExObj, UnlockObject
} from '../../interfaces/interfaces.regisafe';
import {SettingsService} from '../../provider/settings/settings.service';
import {ErrorHandlingService} from '../../provider/error-handling/error-handling.service';
import {MessagesService} from '../../provider/messages/messages.service';
import {AppConfig} from '../../app.config';
import {AlertController, AlertInput, LoadingController} from '@ionic/angular';
import {APP_ASSIGN_FOLDER, APP_CACHE_FOLDER, APP_ICON_PATH, APP_ROUTES} from '../../../environments/environment';
import {UserService} from '../../provider/user/user.service';
import {Chooser} from '@awesome-cordova-plugins/chooser/ngx';
import {Capacitor} from '@capacitor/core';
import {DateiSystemService} from '../../provider/datei-system/datei-system.service';
import {FilePath} from '@awesome-cordova-plugins/file-path/ngx';
import {
	FileTransfer,
	FileTransferObject,
	FileUploadOptions,
	FileUploadResult
} from '@awesome-cordova-plugins/file-transfer/ngx';
import {Location} from '@angular/common';
import {RegisafeGetfileinfoComponent} from '../../components/regisafe-getfileinfo/regisafe-getfileinfo.component';
import {RegisafeRelationsComponent} from '../../components/regisafe-relations/regisafe-relations.component';
import {ALERT_TXT, TOAST_TXT} from '../../strings/language';
import {Camera, CameraOptions} from '@awesome-cordova-plugins/camera/ngx';
import write_blob, {BlobWriteOptions} from 'capacitor-blob-writer';
import {DeleteFileOptions, Directory, Filesystem} from '@capacitor/filesystem';
import {ImagePicker, ImagePickerOptions} from '@awesome-cordova-plugins/image-picker/ngx';
import {FileSystemService} from '../../provider/filesystem/filesystem.service';
import {LaunchNavigator, LaunchNavigatorOptions} from '@awesome-cordova-plugins/launch-navigator/ngx';

@Component({
	selector: 'app-detail',
	templateUrl: './detail.page.html',
	styleUrls: ['./detail.page.scss'],
})
export class DetailPage implements OnInit, OnDestroy {

	@ViewChild(RegisafeGetfileinfoComponent, {static: true}) fileInfoChild: RegisafeGetfileinfoComponent;
	@ViewChild(RegisafeRelationsComponent, {static: true}) relationsChild: RegisafeRelationsComponent;

	public configuration: ConfigurationObject;

	appIconPath = APP_ICON_PATH;

	resizeObservable$: Observable<Event>;
	resizeSubscription$: Subscription;

	title = '';
	details: any = {};
	osFieldsArray: Array<any> = [];
	orgastruktur = '';
	objId = '';
	subStrukturen = [];
	subStructureResults = {};
	subStructureResultsCache = [];
	metadataVisible = true;
	canDeactivate = true;
	objectLocked = false;
	selectedSubStructure: string;
	searchSort = '';

	allowCreate = false;
	createAllowedIn = ['VorgangsVerwaltung', 'Schriftgutverwaltung'];
	createAllowedType = {
		// eslint-disable-next-line @typescript-eslint/naming-convention
		VorgangsVerwaltung: 'Schriftgutverwaltung',
		// eslint-disable-next-line @typescript-eslint/naming-convention
		Schriftgutverwaltung: 'Datei'
	};

	tabcontent = 'metadata';
	loader: HTMLIonLoadingElement;
	alert: HTMLIonAlertElement;

	constructor(private activatedRoute: ActivatedRoute,
				private router: Router,
				private storageService: StorageService,
				private sharedService: SharedDataService,
				private iqAPI: IQApiService,
				private settingsService: SettingsService,
				private msgService: MessagesService,
				private errorHandling: ErrorHandlingService,
				public appConfig: AppConfig,
				private alertCtrl: AlertController,
				private userService: UserService,
				private chooser: Chooser,
				private filePath: FilePath,
				private dateiSystem: DateiSystemService,
				private fileSystemService: FileSystemService,
				private transfer: FileTransfer,
				public location: Location,
				public zone: NgZone,
				private camera: Camera,
				private loadingCtrl: LoadingController,
				private picker: ImagePicker,
				private launchNavigator: LaunchNavigator) {

		this.configuration = this.appConfig.getConfig();

	}

	ngOnDestroy() {
		console.log('ngOnDestroy: ');
	}

	ngOnInit() {
		this.activatedRoute.data.subscribe((response: any) => {

			this.orgastruktur = this.activatedRoute.snapshot.paramMap.get('osid');
			this.objId = this.activatedRoute.snapshot.paramMap.get('objid');
			this.details = response.details.objDatasets;

			this.mergeResultWithOsFieldDesc(this.details);
			if (typeof this.details[0].Aktenzeichen !== 'undefined' && this.details[0].Aktenzeichen.length > 0) {
				this.title = this.userService.setTitle('<strong>' + this.details[0].Aktenzeichen + '</strong>:' + this.details[0].Text);
			} else {
				this.title = this.userService.setTitle(this.details[0].Text);
			}
			this.getSubstructureFromResult(this.details);

			this.sharedService.setRegisafeGlobalData(
				{
					orgastruktur: this.orgastruktur,
					title: this.title,
					iconname: this.sharedService.staticIconValues[this.orgastruktur].icon,
					iconcolor: this.sharedService.staticIconValues[this.orgastruktur].color,
				});

			this.allowCreate = this.createAllowedIn.includes(this.orgastruktur);
		});


		this.resizeObservable$ = fromEvent(window, 'resize');
		this.resizeSubscription$ = this.resizeObservable$.subscribe(evt => {
			this.title = this.userService.setTitle(this.details[0].Text);
		});
	}

	getObjectLockedState(event) {
		this.canDeactivate = !event;
	}

	/**
	 * mergeResultWithOsFieldDesc()
	 *
	 * Die Methode vergleicht die zurückgelieferten Felder mit osFieldDesc (Übersetzungen) aus den Conditions,
	 * und erstellt daraus ein Array von Objecten mit Label und Wert für die Ausgabe der Detailansicht.
	 * Nicht befüllte Felder aus dem Ergebnis der IQAPI Anfrage werden dabei ignoriert, sodass keine
	 * leeren Felder ausgeben werden.
	 *
	 * @param objDataset
	 */
	async mergeResultWithOsFieldDesc(objDataset: Array<any>) {
		console.log('mergeResultWithOsFieldDesc: ', objDataset);
		this.osFieldsArray = [];
		const temp = [];
		const osFieldDesc = await this.storageService.getOsFieldDescFromConditions(this.orgastruktur);
		const osFields = await this.storageService.getOsFieldsFromConditions(this.orgastruktur);

		// Felder ohne Übersetzung zur Ausgabe hinzufügen
		// eslint-disable-next-line no-underscore-dangle
		osFieldDesc._Rechte = 'Zugriff'; // '_Rechte' wird in objDataset mitgeliefert, es gibt in den Conditions jedoch keine Übersetzung

		Object.keys(objDataset[0]).forEach((key) => {
			if (objDataset[0][key] === true || objDataset[0][key] !== '') {
				const labelDesc = osFieldDesc[key];
				const fieldType = this.renameFieldType(osFields[key], key);

				if (typeof labelDesc !== 'undefined') {
					this.osFieldsArray.push({
						osFieldLabel: labelDesc,
						osFieldValue: this.validatePhoneNumberOrEmailOrBool(objDataset[0][key], key),
						osFieldType: fieldType,
						isHiddenByType: this.hiddenFieldByType(osFields[key]),
						isHiddenByName: this.hiddenFieldByName(labelDesc)
					});
				}
			}
		});
	}


	/**
	 * validatePhoneNumberOrEmail()
	 *
	 * Prüft ob es sich beim übergebenen Text um eine Telefonnummer (anhand des Schlüsselnamen)
	 * oder eine E-Mail-Adresse handelt und gibt diese als klickbaren Link zurück
	 *
	 * @param input
	 * @param field
	 */
	validatePhoneNumberOrEmailOrBool(input: any, field: string) {
		// eslint-disable-next-line max-len
		const regExpEmail = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
		const needle = 'telefon';
		const fieldName = field.toLowerCase();
		const excludedFieldNames = ['telefonindex'];

		if (fieldName.includes(needle) && !excludedFieldNames.includes(fieldName)) {
			return '<a href="tel:' + input + '">' + input + '</a>';
		} else if (regExpEmail.test(input)) {
			return '<a href="mailto:' + input + '">' + input + '</a>';
		} else if (typeof input === 'boolean') {
			if (input) {
				return 'Ja';
			} else {
				return 'Nein';
			}
		} else if (field === 'WebAdresse') {
			if (field.includes('http')) {
				return '<a href="' + input + '">' + input + '</a>';
			} else {
				return '<a href="https://' + input + '">' + input + '</a>';
			}
		} else {
			return input;
		}
	}

	/**
	 * hiddenFieldByType()
	 *
	 * blendet Felder nach Typ aus (dabei wird dem Objekt ein boolscher Wert mitgegeben und im Template
	 * das hidden-Attribut entsprechend gesetzt)
 	 * @param type
	 */
	hiddenFieldByType(type: string): boolean {
		const hiddenTypes = ['OBJEKT'];
		return hiddenTypes.includes(type);
	}

	/**
	 * hiddenFieldByName()
	 *
	 * blendet Felder nach Name aus (dabei wird dem Objekt ein boolscher Wert mitgegeben und im Template
	 * das hidden-Attribut entsprechend gesetzt)
	 * @param name
	 */
	hiddenFieldByName(name: string): boolean {
		const hiddenFields = ['Telefonindex', 'TerminObjID', 'Sitzung_TOPSchriftstücke', 'Sitzung_TOPs'];
		return hiddenFields.includes(name);
	}

	/**
	 * renameFieldType()
	 *
	 * Die aus osFields zurückgegebenen Feldtypen werden entsprechend der (statischen) Vorgabe
	 * in HTML taugliche typen umbenannt
	 *
	 * @param field
	 */
	renameFieldType(field, key): string {

		if (typeof field === 'undefined') {
			field = 'Text';
		} else if (field.includes('Text')) {

			const regex = /\d/;
			if (regex.test(field)) {
				const numberInText = parseInt(field.match(/\d+/)[0], 10);
				if (numberInText > 200) {
					field = 'TextLong';
				} else {
					field = 'Text';
				}
			}
		} else if (field.startsWith('Datum') || field.startsWith('DATUM')) { // wird unterschiedlich in der IQAPI (Conditions) geliefert
			field = 'Datum';
		}

		const osFieldTypes = ['Text', 'TextLong', 'Zahl', 'Gleitkommazahl', 'Schalter', 'Datum', 'DatumUndZeit', 'RelDatum'];
		const htmlFieldTypes = ['text', 'textarea', 'number', 'number', 'checkbox', 'jsondate', 'date', 'date'];
		const index = osFieldTypes.indexOf(field);

		return htmlFieldTypes[index];
	}

	/**
	 * getSubstructureFromResult()
	 *
	 * Die übergebenen Felder für untergeordnete Strukturen (SubAktenplanverwaltung, SubVorgangsVerwaltung, ...), welche auf 'true'
	 * gesetzt sind, werden ausgelesen, der Präfix 'Sub' entfernt und an ein Array (subStrukturen) übergeben. Dieses wird an die
	 * Componente '<app-regisafe-footer [substrukturen]="subStrukturen">' als @Input übergeben. Dort werden die zum Objekt
	 * zugehörigen und vorhandenen untergeordneten Strukturen als Buttons ausgegegeben.
	 *
	 * @param objDataset
	 */
	getSubstructureFromResult(objDataset: Array<any>) {
		this.subStrukturen = [];
		Object.keys(objDataset[0]).forEach((key) => {
			if (key.startsWith('Sub') && objDataset[0][key] === true) {
				this.subStrukturen.push(key.replace('Sub', ''));
			}
		});
	}

	/**
	 * loadSubStructureResults()
	 *
	 * Die Methode nimmt die aus der Footer Componente gewählte Struktur
	 * entgegen '<app-regisafe-footer (selectedSubstructure)="loadSubStructureResults($event)">'
	 * und lädt die zum Objekt zugehörigen und vorhandenen untergeordneten Strukturen entsprechend der
	 * gewählten OrgaStruktur
	 *
	 * @param selectedSubStructure
	 */
	async loadSubStructureResults(selectedSubStructure: string, ignoreCache: boolean = true) {

		if (!this.loader) {
			this.loader = await this.loadingCtrl.create({duration: 10000});
			await this.loader.present();
		}

		this.selectedSubStructure = selectedSubStructure;
		this.subStructureResults = {};

		if (typeof this.subStructureResultsCache[selectedSubStructure] !== 'undefined' && !ignoreCache) {
			this.subStructureResults = this.subStructureResultsCache[selectedSubStructure];
			this.dismissLoader();
			return false;
		}

		if (typeof selectedSubStructure === 'undefined') {
			this.subStructureResults = {objDatasets: []};
			this.metadataVisible = true;
			this.dismissLoader();
			return false;
		}

		const signumField = await this.storageService.getOsSignumFieldFromCondtions(this.orgastruktur);

		// Sortierung
		let defaultSortFields = '';
		const defaultSortingFieldsObj = await this.storageService.getSortingData();
		const sortingDataSelection = await this.storageService.getSortingDataSelection();
		let index = 0;

		if (defaultSortingFieldsObj.hasOwnProperty(selectedSubStructure)) {
			if (sortingDataSelection) {
				index = sortingDataSelection[selectedSubStructure];
			}
			defaultSortFields = defaultSortingFieldsObj[selectedSubStructure][index].value;
		} else {
			if (sortingDataSelection) {
				index = sortingDataSelection.Default;
			}
			defaultSortFields = defaultSortingFieldsObj.Default[index].value;
		}

		this.searchSort = defaultSortFields;
		console.log('### defaultSortFields ###: ', defaultSortFields);

		// Query Paramter auslesen und and BODY Object übergeben
		const tempBody: SearchObjectsExObj = {};

		tempBody.osId = selectedSubStructure;
		tempBody.searchText = '';
		tempBody.searchFields = {
			[signumField]: this.details[0][signumField]
		};
		tempBody.apiID = this.configuration.iqapiAppId;
		tempBody.sessionToken = this.storageService.getToken();
		tempBody.sortFields = defaultSortFields;

		const fields = this.storageService.getOSFieldsFromCondtionsSync(tempBody.osId);
		tempBody.fields = fields.join(',');

		const body = Object.assign(tempBody, this.settingsService.defaultBodySettings);

		console.log('### BODY ###: ', body);

		this.iqAPI.orgaManagerSearchObjectsEx(body).subscribe(
			(result: IQApiResultObject) => {
				console.log('### result ###: ', result);
				this.subStructureResults = result;
				this.subStructureResultsCache[selectedSubStructure] = result;
				this.dismissLoader();

				if (result.totalCount === 0) {
					this.errorHandling.errorMessage(TOAST_TXT.message.str00080, 'toast', false, 2000);
				}

			}, (error) => {
				this.dismissLoader();
				this.errorHandling.handleError(error, 'DetailPage -> loadSubStructureResults');
			});
	}

	showMetaData(event: boolean) {
		this.metadataVisible = event;
	}

	add() {

		const allowedType = this.createAllowedType[this.orgastruktur];
		if (allowedType === 'Datei') {
			// Datei hinzufügen
			if (Capacitor.getPlatform() !== 'web') {
				this.openAddAlert();
			} else {
				this.errorHandling.errorMessage('Diese Funktion steht Ihnen im Browser nicht zur Verfügung.', 'toast');
			}
		} else if (allowedType === 'Schriftgutverwaltung') {
			// Objekt anlegen
			this.createObject('Schriftgutverwaltung');
		}
	}

	async openAddAlert() {
		this.alert = await this.alertCtrl.create({
			header: ALERT_TXT.header.str00040,
			subHeader: ALERT_TXT.subHeader.str00060,
			buttons: [
				{
					text: ALERT_TXT.buttons.str00010,
					role: 'cancel'
				}, {
					text: ALERT_TXT.buttons.str00120,
					handler: () => {
						this.fromCamera();
					}
				}, {
					text: ALERT_TXT.buttons.str00110,
					handler: () => {
						this.addFile();
					}
				}, {
					text: ALERT_TXT.buttons.str00100,
					handler: () => {
						this.fromGalery();
					}
				}
			]
		});

		await this.alert.present();
	}

	async fromCamera() {

		// ################### TODO: entfernen wenn über IQAPI umgesetzt ###############
		// bestenfalls sollte beim Hinzufügen einer Datei zu einem Object die IQAPI selber prüfen,
		// ob das Objekt durch denselben Benutzer gesperrt ist und dann den Upload zulassen.
		// Aktuell wird das nicht geprüft und der Benutzer müsste das Objekt selber vorher entsperren und wieder sperren
		//
		// prüfen ob Object gesperrt ist
		// falls ja, entsperren
		const lockedObjects = await this.storageService.getLockedObjects();
		const user = await this.storageService.getConditions('user');

		if (lockedObjects.hasOwnProperty(user.userId)) {
			if (lockedObjects[user.userId].includes(this.userService.objIdAsIQAPIParam(this.objId))) {
				const options: UnlockObject = {
					objID: this.userService.objIdAsIQAPIParam(this.objId),
					osId: this.orgastruktur,
					apiID: this.configuration.iqapiAppId,
					sessionToken: this.storageService.getToken(),
				};
				const unlock = await this.iqAPI.orgaManagerUnlockObject(options)
					.toPromise()
					.catch((e) => {
						this.errorHandling.handleError(e, 'DetailPage -> addFile');
					});
			}
		}
		// ################### TODO: entfernen wenn über IQAPI umgesetzt ###############

		const camOptions: CameraOptions = {
			quality: 80,
			destinationType: this.camera.DestinationType.DATA_URL,
			encodingType: this.camera.EncodingType.JPEG,
			mediaType: this.camera.MediaType.PICTURE
		};
		this.camera.getPicture(camOptions).then(async (imageData) => {

			const dateiname = await this.userService.getCurrentDate() + '_regisafeapp.jpg';
			const blobData = this.userService.base64toBlob(imageData, 'image/jpeg');

			console.log('### fromCamera - dateiname ###: ', dateiname);
			console.log('### fromCamera - blobData ###: ', blobData);

			const blobOptions: BlobWriteOptions = {
				path: APP_CACHE_FOLDER + '/' + dateiname,
				directory: Directory.Documents,
				blob: blobData,
				recursive: true
			};

			write_blob(blobOptions)
				.then(async (data) => {
					console.log('### fromCamera - write_blob ###: ', data);
					const fileObject = {
						uri: data,
						mediaType: 'image/jpeg',
						name: dateiname
					};
					const replacer = [dateiname];
					this.alert = await this.alertCtrl.create({
						header: ALERT_TXT.header.str00040,
						subHeader: this.userService.languageStringReplacer(ALERT_TXT.subHeader.str00070, replacer, '$1'),
						buttons: [{
							text: ALERT_TXT.buttons.str00010,
							role: 'cancel',
							handler: () => {
								this.lockObjectAgain(); // ################### TODO: entfernen wenn über IQAPI umgesetzt ###############
							}
						}, {
							text: ALERT_TXT.buttons.str00170,
							role: 'add',
							handler: () => {
								this.uploadFile(fileObject, true);
							}
						}]
					});

					await this.alert.present();

				})
				.catch((e) => {
					console.log('write_blob error: ', e);
				});


		}, (err) => {
			// Handle error
			console.log('imageData: ', err);
		});
	}

	async addFile() {

		// ################### TODO: entfernen wenn über IQAPI umgesetzt ###############
		// bestenfalls sollte beim Hinzufügen einer Datei zu einem Object die IQAPI selber prüfen,
		// ob das Objekt durch denselben Benutzer gesperrt ist und dann den Upload zulassen.
		// Aktuell wird das nicht geprüft und der Benutzer müsste das Objekt selber vorher entsperren und wieder sperren
		//
		// prüfen ob Object gesperrt ist
		// falls ja, entsperren
		const lockedObjects = await this.storageService.getLockedObjects();
		const user = await this.storageService.getConditions('user');

		if (lockedObjects.hasOwnProperty(user.userId)) {
			if (lockedObjects[user.userId].includes(this.userService.objIdAsIQAPIParam(this.objId))) {
				const options: UnlockObject = {
					objID: this.userService.objIdAsIQAPIParam(this.objId),
					osId: this.orgastruktur,
					apiID: this.configuration.iqapiAppId,
					sessionToken: this.storageService.getToken(),
				};
				const unlock = await this.iqAPI.orgaManagerUnlockObject(options)
					.toPromise()
					.catch((e) => {
						this.errorHandling.handleError(e, 'DetailPage -> addFile');
					});
			}
		}
		// ################### TODO: entfernen wenn über IQAPI umgesetzt ###############

		const file = await this.chooseFile();

		if (!file.name) {
			this.lockObjectAgain(); // ################### TODO: entfernen wenn über IQAPI umgesetzt ###############
			return false;
		}

		let addFile = null;
		const replacer = [file.name];
		const alert = await this.alertCtrl.create({
			header: ALERT_TXT.header.str00040,
			subHeader: this.userService.languageStringReplacer(ALERT_TXT.subHeader.str00070, replacer, '$1'),
			buttons: [{
				text: ALERT_TXT.buttons.str00010,
				role: 'cancel',
				handler: () => {
					this.lockObjectAgain(); // ################### TODO: entfernen wenn über IQAPI umgesetzt ###############
				}
			}, {
				text: ALERT_TXT.buttons.str00170,
				role: 'add',
				handler: () => {
					this.uploadFile(file);
				}
			}]
		});

		await alert.present();
		await alert.onDidDismiss().then((data) => {
			addFile = data;
			if (data.role === 'add') {
			}
		});

		// Datei auswählen

		// Datei hochladen

	}

	async fromGalery() {

		const options: ImagePickerOptions = {
			quality: 80,
			maximumImagesCount: 5,
			outputType: 0
		};
		this.picker.getPictures(options)
			.then(async (images) => {
				console.log('fromGalery: ', images);

				const replacer = [images.length.toString()];
				const alert = await this.alertCtrl.create({
					header: ALERT_TXT.header.str00110,
					subHeader: this.userService.languageStringReplacer(ALERT_TXT.subHeader.str00120, replacer, '$1'),
					buttons: [{
						text: ALERT_TXT.buttons.str00010,
						role: 'cancel',
						handler: () => {

						}
					}, {
						text: ALERT_TXT.buttons.str00170,
						role: 'add',
						handler: () => {
							this.uploadFiles(images);
						}
					}]
				});

				await alert.present();

			})
			.catch((e) => {
				console.log('getPictures error: ', e);
			});
	}


	// ################### TODO: entfernen wenn über IQAPI umgesetzt ###############
	// bestenfalls sollte beim Hinzufügen einer Datei zu einem Object die IQAPI selber prüfen,
	// ob das Objekt durch denselben Benutzer gesperrt ist und dann den Upload zulassen.
	// Aktuell wird das nicht geprüft und der Benutzer müsste das Objekt selber vorher entsperren und wieder sperren
	//
	// Objekt wieder sperren
	async lockObjectAgain() {
		const lockedObjects = await this.storageService.getLockedObjects();
		const user = await this.storageService.getConditions('user');

		if (lockedObjects.hasOwnProperty(user.userId)) {
			if (lockedObjects[user.userId].includes(this.userService.objIdAsIQAPIParam(this.objId))) {
				const options: LockObject = {
					objID: this.userService.objIdAsIQAPIParam(this.objId),
					osId: this.orgastruktur,
					apiID: this.configuration.iqapiAppId,
					sessionToken: this.storageService.getToken(),
				};
				const lock = await this.iqAPI.orgaManagerLockObject(options)
					.toPromise()
					.catch((e) => {
						this.errorHandling.handleError(e, 'DetailPage -> lockObjectAgain');
					});
			}
		}
	}

	// ################### TODO: entfernen wenn über IQAPI umgesetzt ###############

	async chooseFile(): Promise<any> {
		return this.chooser.getFile();
	}

	async uploadFile(fileEntry, deleteFileAfterUpload?: boolean) {

		if (!this.loader) {
			this.loader = await this.loadingCtrl.create({duration: 10000});
			await this.loader.present();
		}

		const parameter = {
			apiID: this.configuration.iqapiAppId,
			sessionToken: this.storageService.getToken(),
			osId: this.orgastruktur,
			objId: this.userService.objIdAsIQAPIParam(this.objId), // 0:0 od 123:456
			fileName: fileEntry.name,
			fileAdd: 1
		};

		const url = this.configuration.iqapiEndpoint + '/OrgaManager.WriteObject';
		const fileTransfer: FileTransferObject = this.transfer.create();
		const transferOption: FileUploadOptions = {
			fileKey: 'binary',
			fileName: fileEntry.name,
			mimeType: fileEntry.mediaType,
			httpMethod: 'POST',
			chunkedMode: false,
			params: parameter
		};

		fileTransfer.onProgress((event) => {
			console.log('orgaManagerWriteObjectAdd.onProgress: ', event.loaded);

			// eslint-disable-next-line max-len
			this.loader.message = this.userService.niceBytes(event.loaded).toString() + ' / ' + this.userService.niceBytes(event.total).toString();
			this.zone.run(() => {
			});
		});

		fileTransfer.upload(fileEntry.uri, url, transferOption, true)
			.catch((e) => {
				console.log('transferObj error: ', e);
				const responseError = {
					error: JSON.parse(e.body)
				};
				this.errorHandling.handleError(responseError, 'uploadFile -> fileTransfer.upload error');
				this.dismissLoader();
				if (deleteFileAfterUpload) {
					this.deleteFile(fileEntry.name);
				}
				this.lockObjectAgain(); // ################### TODO: entfernen wenn über IQAPI umgesetzt ###############
			})
			.then((result) => {
				console.log('transferObj result: ', result);
				this.refreshFileInfo();
				this.dismissLoader();
				if (deleteFileAfterUpload) {
					this.deleteFile(fileEntry.name);
				}
				this.lockObjectAgain(); // ################### TODO: entfernen wenn über IQAPI umgesetzt ###############
			});
	}

	async uploadFiles(files: Array<string>) {

		if (files.length < 1) {
			this.dismissLoader();
			return false;
		}

		// ################### TODO: entfernen wenn über IQAPI umgesetzt ###############
		// bestenfalls sollte beim Hinzufügen einer Datei zu einem Object die IQAPI selber prüfen,
		// ob das Objekt durch denselben Benutzer gesperrt ist und dann den Upload zulassen.
		// Aktuell wird das nicht geprüft und der Benutzer müsste das Objekt selber vorher entsperren und wieder sperren
		//
		// prüfen ob Object gesperrt ist
		// falls ja, entsperren
		const lockedObjects = await this.storageService.getLockedObjects();
		const user = await this.storageService.getConditions('user');

		if (lockedObjects.hasOwnProperty(user.userId)) {
			if (lockedObjects[user.userId].includes(this.userService.objIdAsIQAPIParam(this.objId))) {
				const options: UnlockObject = {
					objID: this.userService.objIdAsIQAPIParam(this.objId),
					osId: this.orgastruktur,
					apiID: this.configuration.iqapiAppId,
					sessionToken: this.storageService.getToken(),
				};
				const unlock = await this.iqAPI.orgaManagerUnlockObject(options)
					.toPromise()
					.catch((e) => {
						this.errorHandling.handleError(e, 'DetailPage -> addFile');
					});
			}
		}
		// ################### TODO: entfernen wenn über IQAPI umgesetzt ###############

		if (!this.loader) {
			this.loader = await this.loadingCtrl.create({duration: 20000});
			await this.loader.present();
		}

		const filename = this.fileSystemService.getFilenameFromPath(files[0]);
		const fileExt = files[0].split('.').pop();
		const mimeType = this.userService.mimeTypes[fileExt];

		const fileEntry = {
			name: decodeURIComponent(filename),
			uri: decodeURIComponent(files[0]),
			type: mimeType
		};

		const parameter = {
			apiID: this.configuration.iqapiAppId,
			sessionToken: this.storageService.getToken(),
			osId: this.orgastruktur,
			objId: this.userService.objIdAsIQAPIParam(this.objId), // 0:0 od 123:456
			fileName: fileEntry.name,
			fileAdd: 1
		};

		const token = this.storageService.getToken();
		const fileTransfer: FileTransferObject = this.transfer.create();
		const transferOption: FileUploadOptions = {
			fileKey: 'binary',
			fileName: fileEntry.name,
			mimeType: fileEntry.type,
			httpMethod: 'POST',
			chunkedMode: false,
			params: parameter
		};

		fileTransfer.onProgress((event) => {
			console.log('transferObj.onProgress: ', event.loaded);
			let markedFilesCount = files.length;
			if (markedFilesCount === 0) {
				markedFilesCount = 1;
			}
			this.loader.message = markedFilesCount.toString() + ' / ' + this.userService.niceBytes(event.loaded).toString();
			this.zone.run(() => {
			});
		});

		const url = this.configuration.iqapiEndpoint + '/OrgaManager.WriteObject';

		fileTransfer.upload(fileEntry.uri, url, transferOption, true)
			.catch((e) => {
				console.log('transferObj error: ', e);
				console.log('transferObj error: ', e.body);
				const responseError = {
					error: JSON.parse(e.body)
				};
				this.errorHandling.handleError(responseError, 'uploadFile -> fileTransfer.upload error');
				this.dismissLoader();
				fileTransfer.abort();
			})
			.then((result) => {
				console.log('transferObj result: ', result);
				if (files.length > 0) {
					files.splice(0, 1);
					setTimeout(() => {
						this.uploadFiles(files);
					}, 1000);
				} else {
					this.dismissLoader();
					this.lockObjectAgain();
					fileTransfer.abort();
				}
			});
	}

	async deleteFile(filename: string) {
		console.log('### deleteFile - loesche 0 ###: ', APP_CACHE_FOLDER, filename);
		const loesche = await this.dateiSystem.loescheDatei(APP_CACHE_FOLDER + filename);
		console.log('### deleteFile - loesche ###: ', loesche);
	}

	/**
	 * createObject()
	 *
	 * @param orgastruct
	 * Diese Methode erstellt ein neues Objekt (Schriftstück, Akte, Aktenzeichen, etc.)S
	 */
	async createObject(orgastruct: string) {

		// Pflichtfelder aus Conditions auslesen
		const conditions = await this.storageService.getConditions('orgaStructs');
		const osFields = conditions[orgastruct].osFields;
		const requiredFields: any = this.storageService.getRequiredFields(osFields, orgastruct);
		const title = await this.storageService.getOsStructNameFromConditionsSync(orgastruct, true);

		// osSuperStructs zur Orgastruktur auslesen und in Feldnamen übersetzen
		// um die Werte aus dem übergeordeneten Object zu übernehmem (Aktenzeichen, VorgangsKennung, Adresskennung, Sitzungskennuing, etc.)
		const osSuperStructsToOsFields = await this.storageService.osSuperStructsToOsFields(orgastruct);

		// Alert ausgeben mit Formular
		let formData = null;
		const form = await this.alertCtrl.create({
			header: ALERT_TXT.header.str00060 + ' - ' + title,
			message: this.details[0].Vorgangskennung + '/' + this.details[0].Text,
			buttons: [{
				text: ALERT_TXT.buttons.str00130
			}, {
				text: ALERT_TXT.buttons.str00010,
				role: 'cancel',
				handler: () => false
			}],
			inputs: requiredFields,
			backdropDismiss: false
		});

		await form.present();
		await form.onDidDismiss().then((data) => {
			formData = data;
		});

		// Falls Benutzer abbricht
		if (!formData.data || formData.role === 'cancel') {
			return false;
		}

		// DatumsString erzeugen für Felder 'Datum' und 'ADatum'
		const date = new Date();
		const day = date.getDate();
		const month = date.getMonth() + 1;
		const year = date.getFullYear();

		const formatted = day + '.' + month + '.' + year;

		// Benutzername auslesen für Feld 'Sachbearbeiter'
		const userData = await this.storageService.getConditions('user');
		const userName = userData.name;

		// Rechte auslesen und übergeben
		// eslint-disable-next-line @typescript-eslint/dot-notation, @typescript-eslint/naming-convention
		const rechteObj = this.details[0]['_Rechte'];

		// Rechte des Benutzers hinzufügen???
		// const userId = userData.userId;
		// rechteObj[userId] = 'LSV';

		const dataset = {
			// eslint-disable-next-line @typescript-eslint/naming-convention
			Text: formData.data.values.Text,
			// eslint-disable-next-line @typescript-eslint/dot-notation, @typescript-eslint/naming-convention
			_Rechte: rechteObj,
			// eslint-disable-next-line @typescript-eslint/naming-convention
			ADatum: formatted,
			// eslint-disable-next-line @typescript-eslint/naming-convention
			Datum: formatted,
			// eslint-disable-next-line @typescript-eslint/naming-convention
			Sachbearbeiter: userName,
		};

		// Werte aus SignumFeldern in 'objDataset' aus Akte übernehmen
		osSuperStructsToOsFields.forEach((field) => {
			if (this.details[0].hasOwnProperty(field)) {
				if (this.details[0][field] !== '') {
					dataset[field] = this.details[0][field];
				}
			}
		});

		const body = {
			apiId: this.configuration.iqapiAppId,
			sessionToken: this.storageService.getToken(),
			osId: orgastruct,
			objId: '0:0',
			objDataset: dataset
		};

		const added = await this.iqAPI.orgaManagerAddObject(body)
			.toPromise()
			.catch((errorResponse) => {
				console.log('createObject -> orgaManagerAddObject: ', errorResponse);
				this.errorHandling.handleError(errorResponse, 'getFile -> orgaManagerLockObject');
			});

		if (added) {
			this.router.navigate([APP_ROUTES.detail, orgastruct, this.userService.objIdAsRouteParam(added.objId)])
				.then((navigated) => {
					// do something or leave it
				});
		}
	}

	refreshFileInfo() {
		this.fileInfoChild.getFileInfo(this.orgastruktur, this.userService.objIdAsIQAPIParam(this.objId), true);
	}

	unlock() {
		this.fileInfoChild.unlockObject();
	}

	lock() {
		this.fileInfoChild.lockObject();
	}

	back(): void {
		this.location.back();
	}

	async dismissLoader() {
		try {
			this.loader.dismiss();
			this.loader = null;
		} catch (e) {
			console.log('dismissToast: ', e);
		}
	}

	// async checkRelations() {
	// 	const body: CheckRelationsObject = {
	// 		apiID: this.configuration.iqapiAppId,
	// 		objID: this.userService.objIdAsIQAPIParam(this.objId),
	// 		osId: this.orgastruktur,
	// 		sessionToken: this.storageService.getToken()
	// 	};
	//
	// 	console.log('checkRelations Body: ', body);
	// 	const response = await this.iqAPI.orgaManagerCheckRelations(body)
	// 		.toPromise()
	// 		.catch((errorResponse) => {
	// 			this.errorHandling.handleError(errorResponse, 'DetailPage -> checkRelations');
	// 		});
	//
	// 	console.log('Relations ###: ', response.relations);
	// }

	async navigateTo() {
		const addressObj = {
			ort: this.details[0].StrOrt,
			plz: this.details[0].StrPLZ,
			strasse: this.details[0].Strasse
		};

		const parametersArray = [
			addressObj.plz,
			addressObj.ort,
			addressObj.strasse];
		const parameters = encodeURI(parametersArray.join(' '));

		const platform = Capacitor.getPlatform();
		switch (platform) {
			case 'web':
				window.open('https://www.google.com/maps/search/?api=1&query=' + parameters, '_system');
				break;
			case 'ios':
				this.openNavigator(addressObj.plz + ', ' + addressObj.ort + ', ' + addressObj.strasse);
				break;
			case 'android':
				window.open('https://www.google.com/maps/search/?api=1&query=' + parameters, '_system');
				break;
		}
	}

	openNavigator(address) {
		const options: LaunchNavigatorOptions = {};
		this.launchNavigator.navigate(address, options)
			.then(
				success => console.log('Launched navigator'),
				error => console.log('Error launching navigator', error)
			);
	}

	async filterResults() {
		const osId = this.selectedSubStructure;

		let input: Array<AlertInput> = [];
		switch (osId) {
			case 'Aktenplanverwaltung':
				input = [
					{
						label: 'Aktenzeichen aufsteigend',
						type: 'radio',
						name: 'filter',
						value: 'Aktenzeichen>',
						checked: this.searchSort === 'Aktenzeichen>'
					}, {
						label: 'Aktenzeichen absteigend',
						type: 'radio',
						name: 'filter',
						value: 'Aktenzeichen<',
						checked: this.searchSort === 'Aktenzeichen<'
					}
				];
				break;

			case 'VorgangsVerwaltung':
				input = [
					{
						label: 'Datum aufsteigend',
						type: 'radio',
						name: 'filter',
						value: 'BeginnDatum>',
						checked: this.searchSort === 'BeginnDatum>'
					}, {
						label: 'Datum absteigend',
						type: 'radio',
						name: 'filter',
						value: 'BeginnDatum<',
						checked: this.searchSort === 'BeginnDatum<'
					}, {
						label: 'Vorgangskennung aufsteigend',
						type: 'radio',
						name: 'filter',
						value: 'Vorgangskennung>',
						checked: this.searchSort === 'Vorgangskennung>'
					}, {
						label: 'Vorgangskennung absteigend',
						type: 'radio',
						name: 'filter',
						value: 'Vorgangskennung<',
						checked: this.searchSort === 'Vorgangskennung<'
					}
				];
				break;
			case 'Schriftgutverwaltung':
				input = [
					{
						label: 'Änderungsdatum aufsteigend',
						type: 'radio',
						name: 'filter',
						value: 'ADatum>',
						checked: this.searchSort === 'ADatum>'
					}, {
						label: 'Änderungsdatum absteigend',
						type: 'radio',
						name: 'filter',
						value: 'ADatum<',
						checked: this.searchSort === 'ADatum<'
					}, {
						label: 'Erstellungsdatum aufsteigend',
						type: 'radio',
						name: 'filter',
						value: 'Datum>',
						checked: this.searchSort === 'Datum>'
					}, {
						label: 'Erstellungsdatum absteigend',
						type: 'radio',
						name: 'filter',
						value: 'Datum<',
						checked: this.searchSort === 'Datum<'
					}, {
						label: 'Aktenzeichen aufsteigend',
						type: 'radio',
						name: 'filter',
						value: 'Aktenzeichen>',
						checked: this.searchSort === 'Aktenzeichen>'
					}, {
						label: 'Aktenzeichen absteigend',
						type: 'radio',
						name: 'filter',
						value: 'Aktenzeichen<',
						checked: this.searchSort === 'Aktenzeichen<'
					}
				];
				break;
			case 'Adressverwaltung':
				input = [
					{
						label: 'Adresskennung aufsteigend',
						type: 'radio',
						name: 'filter',
						value: 'Adresskennung>',
						checked: this.searchSort === 'Adresskennung>'
					}, {
						label: 'Adresskennung absteigend',
						type: 'radio',
						name: 'filter',
						value: 'Adresskennung<',
						checked: this.searchSort === 'Adresskennung<'
					}, {
						label: 'Name aufsteigend',
						type: 'radio',
						name: 'filter',
						value: 'Nachname>;Vorname>',
						checked: this.searchSort === 'Nachname>;Vorname>'
					}, {
						label: 'Name absteigend',
						type: 'radio',
						name: 'filter',
						value: 'Nachname<;Vorname<',
						checked: this.searchSort === 'Nachname<;Vorname<'
					}
				];
				break;
			case 'Sitzungsverwaltung':
				input = [
					{
						label: 'Sitzungsdatum aufsteigend',
						type: 'radio',
						name: 'filter',
						value: 'Sitzungsdatum>',
						checked: this.searchSort === 'Sitzungsdatum>'
					}, {
						label: 'Sitzungsdatum absteigend',
						type: 'radio',
						name: 'filter',
						value: 'Sitzungsdatum<',
						checked: this.searchSort === 'Sitzungsdatum<'
					}
				];
				break;
			default:
				input = [
					{
						label: 'Text aufsteigend',
						type: 'radio',
						name: 'filter',
						value: 'Text>',
						checked: this.searchSort === 'Text>'
					}, {
						label: 'Text absteigend',
						type: 'radio',
						name: 'filter',
						value: 'Text<',
						checked: this.searchSort === 'Text<'
					}
				];
		}

		this.alert = await this.alertCtrl.create({
			header: ALERT_TXT.header.str00050,
			buttons: [
				{
					text: ALERT_TXT.buttons.str00010,
					role: 'cancel'
				}, {
					text: ALERT_TXT.buttons.str00130,
					role: 'filter',
					handler: (data) => data
				}

			],
			inputs: input
		});

		await this.alert.present();

		await this.alert.onDidDismiss().then(async (filter) => {
			if (filter.role !== 'cancel') {
				this.searchSort = filter.data.values;
				await this.storageService.setSortingDataSelection(filter.data.values, this.selectedSubStructure);
				this.loadSubStructureResults(this.selectedSubStructure, true);
			}
		});
	}

}
